import { render, staticRenderFns } from "./BoarderManagementPage.vue?vue&type=template&id=6f9159b9&scoped=true&lang=pug"
import script from "./BoarderManagementPage.vue?vue&type=script&lang=ts"
export * from "./BoarderManagementPage.vue?vue&type=script&lang=ts"
import style0 from "./BoarderManagementPage.vue?vue&type=style&index=0&id=6f9159b9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@6.11.0_webpack@5.109.2_postcss@8_1f9207239c89e69c02e913826d327f44/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9159b9",
  null
  
)

export default component.exports